module.exports = __webpack_public_path__ + "img/33-r.6ce0e0b2.png";